import styled from "styled-components";

export const Content = styled.div`
  overflowy: scroll;
`;

export const Button = styled.div`
  position: fixed;
  width: 100%;
  bottom: 40px;
  height: 20px;
  font-size: 3rem;
  z-index: 1;
  cursor: pointer;
  color: #ff00ac;
`;
